import _ from 'underscore';
import TemplateHtml from '../../../html/engine/arcade/header.html';
import MenuItemHtml from '../../../html/engine/arcade/menuItem.html';
import BaseView from '../../baseView';
import InputManager from '../../manager/inputManager';
import Router from '../../router';

export default class Header extends BaseView {
	get CN() {
		return Header.name;
	}

	get id() {
		return 'header';
	}

	get className() {
		return 'header empty';
	}

	get template() {
		return _.template(TemplateHtml);
	}

	get menuItemTemplate() {
		return _.template(MenuItemHtml);
	}

	get pageClassNames() {
		return '.home';
	}

	initialize(options) {
		this.logger.log(`[${this.initialize.name}]`, options);

		this.pages = [];

		super.initialize(options);

		InputManager.add('menu', {
			selector: '#menu .menu-item:not(.disabled), #header a.brand',
			defaultElement: '#header .menu-item.home',
		});

		this.pageMap = this.pages.reduce((map, page) => {
			map[page.id] = page;
			return map;
		}, {});

		Router.on('route', this.onHashChange.bind(this));

		this.render();
	}

	onHashChange() {
		this.logger.log('[onHashChange]');

		this.updatePage(window.location.hash.replace('#', ''));
	}

	updatePage(newPageHash = 'home') {
		this.logger.log(`[${this.updatePage.name}]`, { newPage: newPageHash });

		if (newPageHash === this.currentPageHash) {
			return;
		}
		this.currentPageHash = newPageHash;

		const newPageData = this.pages.find((page) => {
			if (!page.route) {
				return false;
			}

			let route = page.route || '';
			if (!_.isRegExp(route)) {
				route = Router._routeToRegExp(route);
			} else {
				route = new RegExp(route);
			}

			return route.test(newPageHash);
		});

		const { visiblePages = [], availablePages } = newPageData || this.pages[0];
		const availablePagesSelector = (availablePages || visiblePages)
			.map((page) => `.${page}`)
			.join(', ');

		const menuItems = visiblePages
			.map((pageId) => this.pageMap[pageId])
			.filter((page) => page && page.id)
			.map(this.menuItemTemplate);
		this.logger.debug({ visiblePages, availablePages, menuItems });

		this.$el.find('input[type=checkbox]').prop('checked', false);

		this.dismissView().then(() => {
			this.logger.debug('Update classes');
			const $menu = this.$el.find('#menu').empty();

			if (!menuItems.length) {
				this.$el.addClass('empty');
				return Promise.resolve();
			}
			this.$el.removeClass('empty');

			this.logger.debug({ menuItems });
			$menu.append(menuItems);
			this.$el.find(availablePagesSelector).addClass('available');

			return this.displayView();
		});
	}
}
